import { render, staticRenderFns } from "./DocumentHeaderStock.vue?vue&type=template&id=b9fcedd0&scoped=true&lang=pug&"
import script from "./DocumentHeaderStock.vue?vue&type=script&lang=js&"
export * from "./DocumentHeaderStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fcedd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
